// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-shared-components-Header-components-SignOut-SignOut-module__body {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.src-shared-components-Header-components-SignOut-SignOut-module__body .src-shared-components-Header-components-SignOut-SignOut-module__header {
  width: 100%;
  height: 20%;
  flex: 0 0 var(--space-3xl);
  background: var(--color-bg-system);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  padding: var(--space-xs);
  background: var(--color-bg-system);
  overflow: hidden;
}
.src-shared-components-Header-components-SignOut-SignOut-module__body .src-shared-components-Header-components-SignOut-SignOut-module__content {
  height: 80%;
  width: 100%;
  padding: var(--space-xs);
  flex: 0 0 var(--space-4xl);
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.src-shared-components-Header-components-SignOut-SignOut-module__body .src-shared-components-Header-components-SignOut-SignOut-module__closeBtn {
  margin-top: var(--space-xl);
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Header/components/SignOut/SignOut.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AACD;AACC;EACC,WAAA;EACA,WAAA;EACA,0BAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kCAAA;EACA,gBAAA;AACF;AAEC;EACC,WAAA;EACA,WAAA;EACA,wBAAA;EACA,0BAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAAF;AAGC;EACC,2BAAA;AADF","sourcesContent":[".body {\n\twidth: 100%;\n\tmin-height: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\n\t.header {\n\t\twidth: 100%;\n\t\theight: 20%;\n\t\tflex: 0 0 var(--space-3xl);\n\t\tbackground: var(--color-bg-system);\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\talign-items: center;\n\t\tjustify-content: end;\n\t\tpadding: var(--space-xs);\n\t\tbackground: var(--color-bg-system);\n\t\toverflow: hidden;\n\t}\n\n\t.content {\n\t\theight: 80%;\n\t\twidth: 100%;\n\t\tpadding: var(--space-xs);\n\t\tflex: 0 0 var(--space-4xl);\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n\n\t.closeBtn {\n\t\tmargin-top: var(--space-xl);\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `src-shared-components-Header-components-SignOut-SignOut-module__body`,
	"header": `src-shared-components-Header-components-SignOut-SignOut-module__header`,
	"content": `src-shared-components-Header-components-SignOut-SignOut-module__content`,
	"closeBtn": `src-shared-components-Header-components-SignOut-SignOut-module__closeBtn`
};
export default ___CSS_LOADER_EXPORT___;
